export enum FeatureToggle {
  itemPriceManagement = 'rt_item_price_management',
}
